import Image from "@/components/AppImage";
import how_works_icon_4 from "/public/img/how-works-icon-4.png";
import how_works_icon_5 from "/public/img/how-works-icon-5.png";
import how_works_icon_6 from "/public/img/how-works-icon-6.png";

const HowItsWork = () => {
  return (
    <section className="how-works inner-how-works index-3">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-10">
              <div className="section-header text-center">
                <h2 className="title">Three clicks from signup to invoice</h2>
                <p>
                  Create your profile, add payout details, and issue a branded
                  payment request your clients can settle instantly—no custom
                  dev work required.
                </p>
              </div>
            </div>
          </div>
          <div className="row cus-mar">
            <div className="col-lg-4">
              <div className="single-item d-grid justify-content-center">
                <div className="icon">
                  <div className="iconbg">
                    <Image src={how_works_icon_4} alt="icon" />
                    <span className="xlr">01</span>
                  </div>
                </div>
                <div className="bottom-icon text-center">
                  <h5>Step 1</h5>
                  <p>
                    Create your freelancer account and confirm your identity in
                    guided steps.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="single-item d-grid justify-content-center">
                <div className="icon">
                  <div className="iconbg">
                    <Image src={how_works_icon_5} alt="icon" />
                    <span className="xlr second">02</span>
                  </div>
                </div>
                <div className="bottom-icon text-center">
                  <h5>Step 2</h5>
                  <p>
                    Link the bank account or wallet where you want funds to
                    land.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="single-item d-grid justify-content-center">
                <div className="icon">
                  <div className="iconbg">
                    <Image src={how_works_icon_6} alt="icon" />
                    <span className="xlr third">03</span>
                  </div>
                </div>
                <div className="bottom-icon text-center">
                  <h5>Step 3</h5>
                  <p>
                    Send a payment link; clients pay with cards, ACH, or local
                    rails and you get notified instantly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItsWork;
